/**
 * A person's preferred reporting currency (`User.reportingCurrency`), checked
 * against the codes a given screen can actually report in.
 *
 * Returns the code only when it is one of `allowed`; otherwise `undefined`
 * (no preference, an unknown code, no user yet, or an older API without the
 * key), and the caller keeps its existing default.
 */
export function userReportingCurrency(
  user: { reportingCurrency?: string | null } | null | undefined,
  allowed: readonly string[],
): string | undefined {
  const code = user?.reportingCurrency;
  if (typeof code !== 'string') return undefined;
  return allowed.includes(code) ? code : undefined;
}
